import { render, staticRenderFns } from "./OfferPrintSecondPage.vue?vue&type=template&id=2b305fa1&scoped=true"
import script from "./OfferPrintSecondPage.vue?vue&type=script&lang=js"
export * from "./OfferPrintSecondPage.vue?vue&type=script&lang=js"
import style0 from "./OfferPrintSecondPage.vue?vue&type=style&index=0&id=2b305fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b305fa1",
  null
  
)

export default component.exports